import { userTypeRedirect } from "components/login-page/functions";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useEffect } from "react";
import { useRouter } from "router-manager/parts";
import { RoutePermissionFunction } from "router-manager/parts";

export default function IndexPage() {
  const { user } = useApplicationContext();
  const router = useRouter();

  useEffect(() => {
    router.push(userTypeRedirect(user));
  }, []);

  return <></>;
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission((user) => !!user?.isLogged);
};
